import { convertToExportedView } from '@estee/elc-service';
import { AUTO_REPLENISH } from '@estee/elc-service-view-names';
import { IAutoReplenishment } from './AutoReplenishment';
import serviceNames from '~setup/SubscriptionsService';

/*eslint no-restricted-syntax: ["off"]*/
export default convertToExportedView<IAutoReplenishment>(
    () => import('./AutoReplenishment'),
    AUTO_REPLENISH,
    serviceNames.autoReplenishmentViewController
);
